<template>
  <div>
    <v-row class="mt-4">
      <v-col
        xl="4"
        lg="4"
        md="6"
        sm="6"
        xs="12"
        cols="12"
        class="align-center justify-center text-center"
        v-if="authorDetails.pictureUrl"
      >
        <v-card class="pa-4" outlined>
          <img
            class="w-100"
            :src="
              authorDetails.pictureUrl
                ? authorDetails.pictureUrl
                : '/no-image.png'
            "
            alt=""
          />
        </v-card>
      </v-col>
      <div class="mb-4">
        <h1 class="font-weight-bold mt-1 fs-xxxxxlarge">
          {{ authorDetails.name }}
        </h1>
      </div>
      <!-- <v-col
        xl="9"
        lg="9"
        md="8"
        sm="8"
        xs="12"
        cols="12"
        v-if="authorDetails.description"
      >
        <div>
          <span
            class="fs-medium mainFont--text"
            v-html="formattedDescription"
          ></span></div></v-col
    > -->
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AuthorInfo",
  props: ["authorDetails"],
  computed: {
    formattedDescription() {
      return this.authorDetails.description
        ? this.authorDetails.description
            .replace(/\n/g, "<br>")
            .replace(/<a /g, '<a target="_self" ')
        : "";
    },
  },
};
</script>

<style lang="scss">
.ql-align-justify {
  text-align: justify;
}
</style>
